import { defineStore } from 'pinia';
import DataService from "@/service/DataService";

export const useEnabledStore = defineStore({
    id: 'enabled',
    state: () => ({
        portalTypeBooks: null,
        portalTypeLoading: false,
    }),
    mutations: {
        setPortalType(state, status) {
            state.portalTypeBooks = status;
        },
    },
    actions: {
        async checkPortalType() {
            this.portalTypeLoading = true;
            try {
                const { data } = await DataService.getModulesEnabled();
                // this.portalTypeBooks = true;
                this.portalTypeBooks = Array.isArray(data) && data.length === 1 && data[0] === "Books";
            }  catch (error) {} finally {
                this.portalTypeLoading = false;
            }

        },
    },
    getters: {
        isPortalTypeBooks(state) {
            return state.portalTypeBooks;
        },
        isPortalTypeLoading(state) {
            return state.portalTypeLoading;
        },
    },
});
